export default __webpack_public_path__ + "static/media/004-about-noun_Idea_2053564-1-1.4f58c89f.webp";